export interface FlavorOriginBlock {
  tag: string;
  en: string;
  title: string;
  text: string;
}

export interface FlavorDetail {
  id: string;
  dish: string;
  dishEn: string;
  city: string;
  cityEn: string;
  place: string;
  wish: string;
  characterId?: string;
  characterName?: string;
  image: string;
  intro: string;
  originBlocks: FlavorOriginBlock[];
  story: string[];
  quote: string;
}

export const flavorDetails: FlavorDetail[] = [
  {
    id: 'hangzhou',
    dish: '西湖醋鱼',
    dishEn: 'WEST LAKE FISH IN VINEGAR',
    city: '杭州',
    cityEn: 'HANGZHOU',
    place: '江南烟雨 · 温柔松弛',
    wish: '好运 · 好生活',
    characterId: 'yu-doudou',
    characterName: '鱼豆豆',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20elegant%20plate%20of%20Chinese%20West%20Lake%20vinegar%20fish%20with%20glossy%20amber%20sweet%20sour%20sauce%20and%20fine%20ginger%20on%20a%20ceramic%20dish%20warm%20beige%20rice%20paper%20background%20minimal%20editorial%20food%20photography%20soft%20natural%20light%20high%20detail&width=1000&height=1000&seq=nomo-flavor-hangzhou-01&orientation=squarish',
    intro:
      '杭州菜里的名角，酸甜交织，像人生有酸也有甜。一道西湖醋鱼，藏着江南人对「年年有余」最朴素的盼望。',
    originBlocks: [
      {
        tag: '一味',
        en: 'FLAVOR',
        title: '西湖醋鱼',
        text:
          '草鱼取中段，入沸水氽熟，浇上一勺糖醋芡汁。鱼肉嫩滑、酸甜开胃，是杭帮菜里最有名的一道。',
      },
      {
        tag: '一境',
        en: 'PLACE',
        title: '杭州 · 西湖',
        text:
          '三面云山一面城，西湖是江南最温柔的一片水。这道菜吃的，正是这方水土养出来的清鲜与柔和。',
      },
      {
        tag: '一愿',
        en: 'WISH',
        title: '好运 · 好生活',
        text:
          '「鱼」与「余」同音，讨一个「年年有余」的好彩头。愿日子有酸有甜，但总有回甘。',
      },
    ],
    story: [
      '西湖醋鱼到底好不好吃，杭州人自己都争论了几十年。有人说它太酸，有人说它太甜，可谁家宴客，桌上又总少不了一道它。',
      '也许重要的从来不是那口味道，而是这道菜背后的念想——一年到头，有鱼有余，日子便不算亏待自己。',
    ],
    quote: '愿你，也被生活温柔以待，好运常伴。',
  },
  {
    id: 'beijing',
    dish: '北京烤鸭',
    dishEn: 'PEKING ROAST DUCK',
    city: '北京',
    cityEn: 'BEIJING',
    place: '皇城胡同 · 讲究与热闹',
    wish: '圆满 · 富足',
    characterId: 'ya-longlong',
    characterName: '鸭珑珑',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20plate%20of%20Chinese%20Peking%20duck%20with%20crispy%20glossy%20caramel%20skin%20sliced%20thin%20on%20a%20white%20ceramic%20plate%20with%20steamed%20pancakes%20and%20spring%20onion%20warm%20beige%20background%20minimal%20editorial%20food%20photography%20soft%20light%20high%20detail&width=1000&height=1000&seq=nomo-flavor-beijing-01&orientation=squarish',
    intro:
      '果木炭火烤出的枣红鸭皮，酥香流油，配上一张薄饼、几缕甜面酱，是京城最体面的待客之道。',
    originBlocks: [
      {
        tag: '一味',
        en: 'FLAVOR',
        title: '北京烤鸭',
        text:
          '选一只填鸭，用果木炭火慢慢烤到皮色枣红。片成薄片，裹进荷叶饼里，是刻进京城记忆的酥香。',
      },
      {
        tag: '一境',
        en: 'PLACE',
        title: '北京 · 皇城',
        text:
          '红墙黄瓦与胡同灰砖，古老与鲜活并存。一顿烤鸭，吃的是皇城根下的讲究，也是胡同里的人情。',
      },
      {
        tag: '一愿',
        en: 'WISH',
        title: '圆满 · 富足',
        text:
          '鸭圆润饱满，象征圆满；一顿丰盛的烤鸭，更藏着对富足体面日子的朴素向往。',
      },
    ],
    story: [
      '老北京请客，讲究一个「面儿」。上了烤鸭，这顿饭才算有了分量。师傅在客人面前片鸭，刀起刀落，片片匀称，是一场小小的仪式。',
      '鸭珑珑正是从这份「讲究」里长出来的——它相信，再小的一顿饭，也要吃得体面，过得圆满。',
    ],
    quote: '再小的一顿饭，也要吃得体面，过得圆满。',
  },
  {
    id: 'chongqing',
    dish: '麻辣火锅',
    dishEn: 'SPICY HOTPOT',
    city: '重庆',
    cityEn: 'CHONGQING',
    place: '山城江湖 · 热辣直爽',
    wish: '红火 · 热闹',
    characterId: 'la-dundun',
    characterName: '辣墩墩',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20Chinese%20hotpot%20with%20bubbling%20red%20chili%20broth%20in%20a%20divided%20pot%20surrounded%20by%20fresh%20ingredients%20on%20a%20wooden%20table%20warm%20beige%20background%20minimal%20editorial%20food%20photography%20rising%20steam%20soft%20light%20high%20detail&width=1000&height=1000&seq=nomo-flavor-chongqing-01&orientation=squarish',
    intro:
      '九宫格里翻滚的红汤，麻辣鲜香，是重庆最滚烫的江湖气。一筷子涮下去，热闹和痛快就一起起来了。',
    originBlocks: [
      {
        tag: '一味',
        en: 'FLAVOR',
        title: '麻辣火锅',
        text:
          '牛油打底，辣椒花椒在红汤里翻滚。毛肚七上八下，鸭肠几秒即熟，麻辣是山城写在锅里的性格。',
      },
      {
        tag: '一境',
        en: 'PLACE',
        title: '重庆 · 山城',
        text:
          '两江交汇，吊脚楼依山而建，轻轨穿楼而过。重庆的立体与热辣，都浓缩在一锅沸腾的红汤里。',
      },
      {
        tag: '一愿',
        en: 'WISH',
        title: '红火 · 热闹',
        text:
          '火锅要人多吃才热闹。辣墩墩想把日子过成一锅沸腾的火锅，热气腾腾、红红火火。',
      },
    ],
    story: [
      '重庆人的感情，一半在火锅里。失恋了吃火锅，升职了吃火锅，久别重逢更要吃火锅。锅一滚，什么心事都化了。',
      '九宫格一格一格，装着不同的讲究，也装着一座城的江湖气。辣墩墩就是那团不肯熄灭的火。',
    ],
    quote: '日子嘛，要滚起来才带劲，越滚越红火。',
  },
  {
    id: 'chengdu',
    dish: '甜水面',
    dishEn: 'SWEET WATER NOODLES',
    city: '成都',
    cityEn: 'CHENGDU',
    place: '天府平原 · 闲适安逸',
    wish: '长久 · 康健',
    characterId: 'mian-changchang',
    characterName: '面长长',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20bowl%20of%20Chengdu%20sweet%20water%20noodles%20with%20thick%20wheat%20noodles%20in%20sweet%20spicy%20red%20sauce%20topped%20with%20crushed%20peanuts%20and%20scallions%20warm%20beige%20background%20minimal%20editorial%20food%20photography%20soft%20light%20high%20detail&width=1000&height=1000&seq=nomo-flavor-chengdu-01&orientation=squarish',
    intro:
      '成都街头的一碗甜水面，甜中带辣、面条粗壮有嚼劲。一筷子下去，是川西坝子最朴实的满足。',
    originBlocks: [
      {
        tag: '一味',
        en: 'FLAVOR',
        title: '甜水面',
        text:
          '粗壮的手工面条，拌上红油、酱油与糖，甜辣交融。它不是大菜，却是老成都最惦记的一口。',
      },
      {
        tag: '一境',
        en: 'PLACE',
        title: '成都 · 天府',
        text:
          '平原沃野，茶馆里的龙门阵一摆就是一下午。成都不慌不忙，把「安逸」过成了一种生活哲学。',
      },
      {
        tag: '一愿',
        en: 'WISH',
        title: '长久 · 康健',
        text:
          '面条越长，情意越长。面长长想把「长长久久」的祝福，绕进每一个平凡而安稳的日子里。',
      },
    ],
    story: [
      '甜水面看着简单，其实讲究得很：酱要熬得浓，面要拉得粗，甜和辣要刚刚好。就像过日子，酸甜苦辣都得拿捏住。',
      '一根到底、怎么也拉不断的面，是面长长对「长长久久」最朴素的理解。',
    ],
    quote: '慢一点没关系，心意拉得长，才够用一辈子。',
  },
  {
    id: 'guangdong',
    dish: '早茶虾饺',
    dishEn: 'HAR GOW',
    city: '广东',
    cityEn: 'GUANGDONG',
    place: '岭南水乡 · 一盅两件',
    wish: '团圆 · 聚首',
    characterId: 'xia-jiaojiao',
    characterName: '虾饺饺',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20bamboo%20steamer%20of%20translucent%20crystal%20shrimp%20dumplings%20har%20gow%20with%20pink%20shrimp%20filling%20on%20a%20ceramic%20plate%20warm%20beige%20background%20minimal%20editorial%20food%20photography%20soft%20light%20high%20detail&width=1000&height=1000&seq=nomo-flavor-guangdong-01&orientation=squarish',
    intro:
      '半透明的澄面皮裹着鲜虾，晶莹剔透、鲜甜弹牙。一笼虾饺，是岭南早茶桌上最受欢迎的主角。',
    originBlocks: [
      {
        tag: '一味',
        en: 'FLAVOR',
        title: '早茶虾饺',
        text:
          '澄面皮薄如蝉翼，裹着整只鲜虾，褶子捏得细密均匀。一口下去，鲜甜弹牙，是早茶的灵魂。',
      },
      {
        tag: '一境',
        en: 'PLACE',
        title: '广东 · 岭南',
        text:
          '水乡河网密布，骑楼下茶楼飘香。岭南人爱热闹，一盅两件，就能把清晨过成一场欢聚。',
      },
      {
        tag: '一愿',
        en: 'WISH',
        title: '团圆 · 聚首',
        text:
          '早茶的精髓，从来不是茶，而是一家人围坐一桌的热闹。虾饺饺想把散落各地的人重新聚回来。',
      },
    ],
    story: [
      '广东人的早茶，可以从清晨一直喝到中午。虾饺、烧卖、凤爪摆得满满当当，阿公阿婆、阿爸阿妈，一坐就是一上午。',
      '虾饺饺最爱这样的早晨——它想，一家人围坐一桌，就是这世上最暖的早茶。',
    ],
    quote: '一家人围坐一桌，就是这世上最暖的早茶。',
  },
  {
    id: 'xian',
    dish: '腊汁肉夹馍',
    dishEn: 'ROU JIA MO',
    city: '西安',
    cityEn: "XI'AN",
    place: '长安城墙 · 千年烟火',
    wish: '踏实 · 饱足',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20Chinese%20roujiamo%20meat%20sandwich%20with%20shredded%20braised%20pork%20in%20a%20crispy%20baked%20flatbread%20on%20a%20wooden%20board%20warm%20beige%20background%20minimal%20editorial%20food%20photography%20soft%20light%20high%20detail&width=1000&height=1000&seq=nomo-flavor-xian-01&orientation=squarish',
    intro:
      '一块烤得酥脆的白吉馍，夹上剁碎的腊汁肉，肥而不腻、瘦而不柴。一口下去，是长安城里最踏实的满足。',
    originBlocks: [
      {
        tag: '一味',
        en: 'FLAVOR',
        title: '腊汁肉夹馍',
        text:
          '腊汁肉文火慢炖，肥瘦相间、入口即化，夹进刚出炉的白吉馍里，馍酥肉香，一口满溢。',
      },
      {
        tag: '一境',
        en: 'PLACE',
        title: '西安 · 长安',
        text:
          '十三朝古都，城墙巍峨，千年烟火不断。一碗面、一块馍，都带着历史沉淀下来的厚重与踏实。',
      },
      {
        tag: '一愿',
        en: 'WISH',
        title: '踏实 · 饱足',
        text:
          '肉夹馍不花哨，却最顶饱。馍圆圆想替每个奔波的人，找回那份实实在在的踏实与饱足。',
      },
    ],
    story: [
      '西安的清晨，是从一个肉夹馍开始的。刚出炉的馍还烫手，腊汁肉的香混着麦香，是这座古城最熟悉的烟火气。',
      '它不精致，却最实在。馍圆圆正是从这份「踏实」里长出来的——愿每个奔波的人，都能吃得饱、睡得香。',
    ],
    quote: '再忙的日子，也要先吃一口踏实的饱足。',
  },
];